import React from 'react';
import { Hero } from '../components/home/Hero';
import { Dismissals } from '../components/home/Dismissals';
import { DecoderTeaser } from '../components/home/DecoderTeaser';
import { StageRail } from '../components/home/StageRail';
import { NightBand } from '../components/home/NightBand';
import { Voices } from '../components/home/Voices';
import { CirclesPreview } from '../components/home/CirclesPreview';
import { LibraryPreview } from '../components/home/LibraryPreview';
import { Commitments } from '../components/home/Commitments';
import { CarePathTable } from '../components/care/CarePathTable';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FaqList } from '../components/ui/FaqList';
import { CtaBand } from '../components/ui/CtaBand';
import { carePaths } from '../data/carePaths';
import { faqs } from '../data/site';
import { useBrand } from '../contexts/BrandContext';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
interface HomeProps {
  heroVariant?: 'portrait' | 'statement';
  nightBand?: boolean;
}
export function Home({
  heroVariant = 'portrait',
  nightBand = true
}: HomeProps) {
  const {
    brand
  } = useBrand();
  useDocumentMeta({
    title: brand.copy.metaTitle,
    description: brand.copy.metaDescription
  });
  return <main className="w-full bg-cream" data-id="element-568" data-mp="2mx0ferwqv37c">
      <Hero variant={heroVariant} data-id="element-569" data-mp="2mvyulvpxf2cf" />
      <Dismissals data-id="element-570" data-mp="2mz35fbxwcwc2" />
      <DecoderTeaser data-id="element-571" data-mp="2hxx974512qxs" />
      <StageRail data-id="element-572" data-mp="2hyfhiz4ysvm2" />

      <section className="bg-cream-light" aria-labelledby="care-heading" data-id="element-573" data-mp="2hyyvk4rhuzut">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-574" data-mp="2d6oz05vvj1jk">
          <SectionHeading eyebrow="Care paths" title="Organised by what you’re living with." intro="Not by what we happen to sell. Every path is led by a clinician trained specifically in this transition, and every one of them will tell you when hormone therapy is not the answer." data-id="element-575" data-mp="2883z67kjajvn" />
          <CarePathTable items={carePaths} data-id="element-576" data-mp="1u82yas49rcg6" />
        </div>
      </section>

      {nightBand && <NightBand data-id="element-577" data-mp="1kk7g6tsfdaf8" />}

      <Voices limit={4} data-id="element-578" data-mp="1kjnwb7j7sbyk" />
      <CirclesPreview data-id="element-579" data-mp="1kj5vdxllx9kb" />
      <LibraryPreview data-id="element-580" data-mp="1kn3cyesjdt23" />
      <Commitments data-id="element-581" data-mp="1om2d7m3bp1n7" />

      <section className="bg-cream-light" aria-labelledby="faq-heading" data-id="element-582" data-mp="1ondijqcf2hgf">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-583" data-mp="1amt04vaeynng">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-584" data-mp="1aovyq3pmtp3s">
            <SectionHeading eyebrow="Asked constantly" title="The questions we get in the first four minutes." data-id="element-585" data-mp="1flw74l9yf3y2" />
            <div data-id="element-586" data-mp="28atbdkhbz07t">
              <h2 id="faq-heading" className="sr-only" data-id="element-587" data-mp="2899vvw3i0t73">
                Frequently asked questions
              </h2>
              <FaqList items={faqs} data-id="element-588" data-mp="1tkvttndwp8rl" />
            </div>
          </div>
        </div>
      </section>

      <CtaBand data-id="element-589" data-mp="1yixegcqzdg56" />
    </main>;
}